import{ENCRYPTED_BANK_LOCATION_FIELD as n,ENCRYPTED_BANK_ACCNT_NUMBER_FIELD as o}from"../../../constants.js";function t(t){let e;return t===n&&(e=o),{fieldToFocus:e,additionalField:undefined}}export{t as shiftTabACH};
